// Handle search input placeholder visibility
document.addEventListener('DOMContentLoaded', function() {
  const searchInputs = document.querySelectorAll('.search__input.field__input');
  
  searchInputs.forEach(input => {
    // Store original placeholder
    const originalPlaceholder = input.getAttribute('placeholder');
    
    // Remove placeholder on focus
    input.addEventListener('focus', function() {
      this.setAttribute('placeholder', '');
    });
    
    // Restore placeholder on blur if input is empty
    input.addEventListener('blur', function() {
      if (this.value === '') {
        this.setAttribute('placeholder', originalPlaceholder);
      }
    });
  });
});
